import React from "react";
import styles from "./InstitueAbout.module.css";

const InstitueAbout = (props) => {
  const {
    estYear,
    naacAccreditation,
    institutionType,
    brochure,
    coordDepartment,
    imparc_id
  } = props.profile;
  return (
    <div className={styles.blueBorderBlock}>
      <div className={styles.heading}>
        <h4>Quick Information</h4>
      </div>
      <div className={styles.content}>
      {imparc_id &&  <p className={styles.imparcId}>
          Imparc Id
          <span>{imparc_id}</span>
        </p>}
        <p className={styles.type}>
          Type
          <span>{institutionType}</span>
        </p>
        <p className={styles.established}>
          Established <span>{estYear}</span>
        </p>
        <p className={styles.students}>
          Students<span>8000+ </span>
        </p>
        <p className={styles.faculty}>
          Faculty<span>800+</span>
        </p>
        <p className={styles.campus}>
          Campus Size<span>320 Acres </span>
        </p>
        <p className={styles.acceditation}>
          Acceditation<span>{naacAccreditation}</span>
        </p>
        <h4>Departments</h4>
        <ul>
          <li>{coordDepartment}</li>
        </ul>
        <button
          className={styles.downloadBtn}
          onClick={() => window.open(brochure, "_blank")}
        >
          Download Brochure
        </button>
      </div>
    </div>
  );
};

export default InstitueAbout;
